<template>
  <div class="page-container">
    <div class="page-title">
      {{ $t('menu.split_transaction') }}
    </div>
    <div class="pay-trans-details">
      <div class="filter-section-container">
        <div class="filter-fixed">
          <span class="filter-fixed-title">{{ $t('data.filter_section') }}</span>
          <i
            class="el-icon-arrow-down filter-fixed-arrow"
            :class="{'fiter-icon-arrow-route':!showFilterContent}"
            @click="onClickFixedArrow"
          />
        </div>
        <el-collapse-transition>
          <div v-show="showFilterContent">
            <div id="filter-content" class="filter-content">
              <div class="filter-item">
                <div class="filter-item-label">{{ $t('data.split_transaction_no') }}</div>
                <el-input v-model="search.split_payment_no" size="small" type="text" class="filter-item-value" clearable />
              </div>

              <div class="filter-item">
                <div class="filter-item-label">{{ $t('data.split_detail_transaction_no') }}</div>
                <el-input v-model="search.detail_no" size="small" type="text" class="filter-item-value" clearable />
              </div>

              <div class="filter-item">
                <div class="filter-item-label">{{ $t('data.split_merchant_no_or_name') }}</div>
                <el-input v-model="search.send_merchant_no_or_name" size="small" type="text" class="filter-item-value" clearable />
              </div>

              <div class="filter-item">
                <div class="filter-item-label">{{ $t('data.receiver_type') }}</div>
                <el-select v-model="search.receiver_type" filterable class="filter-item-value" size="small" clearable>
                  <el-option
                    v-for="(item,index) in receiverTypeMap"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </div>

              <div class="filter-item">
                <div class="filter-item-label">{{ $t('data.receiver_account') }}</div>
                <el-input v-model="search.receiver_account" size="small" type="text" class="filter-item-value" clearable />
              </div>

              <div class="filter-item">
                <div class="filter-item-label">{{ $t('components.status') }}</div>
                <el-select v-model="search.split_detail_status" class="filter-item-value" size="small" clearable>
                  <el-option
                    v-for="(item,index) in splitStatusMap"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </div>

              <div class="filter-item">
                <div class="filter-item-label">{{ $t('merchantAccount.create_time') }}</div>
                <el-date-picker
                  v-model="search.create_time"
                  class="filter-item-value"
                  size="small"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :default-time="['00:00:00','23:59:59']"
                  type="daterange"
                  range-separator="~"
                  :start-placeholder="$t('components.start_date')"
                  :end-placeholder="$t('components.end_date')"
                />
              </div>

              <div class="filter-item">
                <div class="filter-item-label">
                  {{ $t('merchantAccount.complete_time') }}
                </div>

                <el-date-picker
                  v-model="search.finish_time"
                  class="filter-item-value"
                  size="small"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :default-time="['00:00:00','23:59:59']"
                  type="daterange"
                  range-separator="~"
                  :start-placeholder="$t('components.start_date')"
                  :end-placeholder="$t('components.end_date')"
                />
              </div>

              <div class="filter-item">
                <!-- <div class="filter-item-label">{{ $t('customerService.app_name') }}</div>
                <el-input v-model="search.app_name" size="small" type="text" class="filter-item-value" clearable /> -->
              </div>
            </div>
            <div class="filter-operate">
              <div class="filter-operate-left">
                <el-button class="mb-10 download-btn" :loading="downloading" type="info" size="small" icon="el-icon-download" @click="onClickDowmloadBtn">{{ $t('components.download') }}</el-button>
              </div>
              <div class="filter-operate-right">
                <el-button class="search-btn mb-10" size="small" @click="onClickReset">{{ $t('components.clear') }}</el-button>
                <el-button class="search-btn mb-10" type="primary" size="small" icon="el-icon-search" @click="handleFilter()">{{ $t('components.search') }}</el-button>
              </div>

            </div>
          </div>

        </el-collapse-transition>
      </div>
      <div class="total-container">
        <div class="total-item">{{ $t('data.total_count') }}: <span style="color:#3855F1;">{{ total_count }}</span>
        </div>
        <div class="total-item">{{ $t('data.total_amount') }}: <span style="color:#3855F1;">{{ $store.getters.currency }}  {{ total_amount | toDivideWithDot }}</span>
        </div>

      </div>
      <div class="tableContainer">
        <!-- 列表 -->
        <el-table
          v-loading="listLoading"
          :data="tableData"
          stripe
          fit
          highlight-current-row
          style="width: 100%"
        >

          <el-table-column :label="$t('data.split_transaction_no')" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.split_payment_no }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="$t('data.split_detail_transaction_no')" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.detail_no }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="$t('data.transaction_no')" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.transaction_id }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="$t('data.split_merchant')" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.send_merchant_no }} - {{ scope.row.send_merchant_name }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="$t('data.receiver_type')" align="center">
            <template slot-scope="scope">
              <span>{{ receiverTypeMapLable( scope.row.receiver_type) }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="$t('data.receiver_account')" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.receiver_account }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="$t('components.amount')" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.split_amount | toDivideWithDot }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="$t('components.status')" align="center">
            <template slot-scope="scope">
              <span>{{ getSplitStatusMapLabel(scope.row.split_detail_status) }}</span>
            </template>
          </el-table-column>

          <el-table-column width="105" :label="$t('merchantAccount.create_time')" align="center">
            <template slot-scope="scope">
              {{ scope.row.transaction_create_time }}
            </template>
          </el-table-column>

          <el-table-column width="105" :label="$t('merchantAccount.complete_time')" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.transaction_return_time }}</span>
            </template>
          </el-table-column>

          <!--操作-->
          <el-table-column :label="$t('components.operation')" align="center" min-width="100">
            <template slot-scope="scope">
              <el-tooltip placement="top">
                <div slot="content">
                  <span> {{ $t('components.detail') }}</span> <br>
                </div>
                <svg-icon class-name="icon-function" icon-class="operation-detail" @click="showDetailModal(scope.row)" />
              </el-tooltip>
            </template>
          </el-table-column>

        </el-table>

        <div class="pagination-container">
          <paginator v-if="!listLoading" :list-query="listQuery" @paginator-change="onClickPaginator" />
        </div>
      </div>
      <SplitTransactionDetailModal ref="splitTransactionDetailModal" />
    </div>
  </div>
</template>

<script>

import { PostGetSplitPaymentOrderList, PostGetSplitPaymentOrderListDownload } from '@/api/data/data'

import {
  receiverTypeMap,
  splitStatusMap
} from '@/utils/maps'
import { filterEmptyAttr, exportXlsx } from '@/utils/common'
import { appointDate } from '@/utils/index.js'

export default {
  components: {
    Paginator: () => import('@/views/components/Paginator'),
    SplitTransactionDetailModal: () => import('./components/Modal/SplitTransactionDetailModal')
  },
  data() {
    return {
      showFilterContent: true,
      search: {
        split_payment_no: '',
        split_detail_status: null, // 交易状态
        create_time: [appointDate(-3) + ' 00:00:00', appointDate() + ' 23:59:59'],
        finish_time: [],
        detail_no: '',
        send_merchant_no_or_name: '',
        receiver_account: '',
        receiver_type: null,
      },
      tableData: [],
      total_amount: 0,
      total_count: 0,
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 15,
        total: 0
      },
      downloading: false
    }
  },
  computed: {
    getSplitStatusMapLabel() {
      return function(value) {
        return splitStatusMap(value).label
      }
    },
    splitStatusMap() {
      return splitStatusMap()
    },
    receiverTypeMap() {
      return receiverTypeMap()
    },
    receiverTypeMapLable() {
      return function(val) {
        return receiverTypeMap(val).label
      }
    }
  },
  created() {
    this.handleFilter()
  },
  methods: {
    getTableData(params) {
      this.listLoading = true
      PostGetSplitPaymentOrderList(params).then(res => {
        // eslint-disable-next-line no-unused-vars
        const { total = 15, list = [], total_count, total_amount } = res.data || {}
        this.listQuery.total = total
        this.listQuery.page = params.page ? params.page : 1
        this.tableData = list
        this.total_amount = total_amount
        this.total_count = total_count
      }).finally(() => {
        this.listLoading = false
      })
    },
    getParams(otherParams = {}) {
      const { create_time = [], finish_time = [], ...otherSearch } = this.search
      let params = {
        create_time_start: create_time && create_time[0],
        create_time_end: create_time && create_time[1],
        finish_time_start: finish_time && finish_time[0],
        finish_time_end: finish_time && finish_time[1],
        ...otherSearch,
        ...otherParams
      }
      params = filterEmptyAttr(params)
      return params
    },

    showDetailModal(row) {
      this.$refs.splitTransactionDetailModal.showModal(row)
    },

    handleFilter(otherParams = {}) {
      if (!this.$commonFn.checkSubmitDateLimit(this.search.create_time, 31)) {
        this.$message.warning('The maximum date range  is limited to 31 days, please select again')
        return
      }
      if (!this.$commonFn.checkSubmitDateLimit(this.search.finish_time, 31)) {
        this.$message.warning('The maximum date range  is limited to 31 days, please select again')
        return
      }
      const params = this.getParams(otherParams)
      if (!params) {
        return
      }
      this.getTableData(params)
    },

    onClickFixedArrow() {
      this.showFilterContent = !this.showFilterContent
    },
    onClickReset() {
      this.search = {}
    },

    onClickDowmloadBtn() {
      // if (!this.$commonFn.checkSubmitDateLimit(this.search.create_time, 31)) {
      //   this.$message.warning('The maximum date range  is limited to 31 days, please select again')
      //   return
      // }
      // if (!this.$commonFn.checkSubmitDateLimit(this.search.finish_time, 31)) {
      //   this.$message.warning('The maximum date range  is limited to 31 days, please select again')
      //   return
      // }
      const params = this.getParams()
      if (!params) {
        return
      }
      this.downloading = true
      PostGetSplitPaymentOrderListDownload(params).then(res => {
        const { data } = res
        if (!data.is_async) {
          const { list } = data
          this.handleXlsxData(list).then((downloadData) => {
            exportXlsx(downloadData, 'Split_Transaction')
          })
        } else {
          this.$store.commit('app/SET_SHOW_DOWNLOAD_LIST', true)
        }
      }).finally(() => {
        setTimeout(() => {
          this.downloading = false
        }, 3000)
      })
    },

    handleXlsxData(data = []) {
      const rows = [[
        this.$t('customerService.transaction_id'),
        this.$t('merchantAccount.merchant_order_id'),
        this.$t('merchantAccount.transaction_amount'),
        this.$t('merchant.service_fee'),
        this.$t('merchantAccount.recipient_name'),
        this.$t('merchantAccount.recipient_mobile'),
        this.$t('merchantAccount.transaction_status'),
        this.$t('merchant.payment_channel'),
        // this.$t('merchantAccount.pay_trans_id'),
        this.$t('merchantAccount.create_time'),
        this.$t('merchantAccount.complete_time')
      ]]

      // const toDivideWithDot = this.$options.filters['toDivideWithDot']
      if (Array.isArray(data) && data.length > 0) {
        data.forEach((tr) => {
          rows.push([
            tr.split_payment_no,
            tr.merchant_order_id,
            tr.amount,
            tr.fee,
            tr.name,
            tr.mobile,
            tr.split_detail_status,
            tr.payment_channel,
            tr.create_time,
            tr.complete_time
          ])
        })
      }
      return Promise.resolve(rows)
    },
    onClickPaginator() {
      this.handleFilter(this.listQuery)
    }
  }
}
</script>

<style lang="scss" scoped>
.page-container{
  margin: 40px 57px 50px 32px;
}
.page-container .page-title{
  padding-bottom: 24px;
  border-bottom: 1px solid #D3D7DF;
}
.pay-trans-details{
  .transTime{
    display: inline-block;
    padding: 0 20px 10px 0;
    font-size: 14px;
    font-weight: 500;  font-family: 'Inter-Medium';
    color: #606266;
  }
  .filter-container{
    padding: 20px 0 0 20px;
  }
  .search-frame {
    width: 230px;
    margin-right: 5px;
  }
  .search-frame-order{
    width:200px;
  }
  .search-btn {
    margin-right: 10px;
  }
  .download-btn{
    margin: 0;
  }
  .picker{
    width: 230px
  }
  .mb-10{
    margin-bottom: 10px;
  }
  .detailTxt{
    font-size: 12px;
    color: #3579FF;
    text-decoration: underline;
     cursor: pointer;
  }
  .total-container{
    display: flex;
    border: 1px solid #D3D7DF;
    margin-bottom: 32px;
    .total-item{
      padding: 10px 0;
      flex: 1;
      text-align: center;
      border-right: 1px solid #D3D7DF;
      font-weight: 400;
      font-size: 14px;
      color: #4B5567;
    }
    .total-item:not(:last-child){
      border-right: 1px solid #D3D7DF;
    }
  }
  .total{
    border-top: 1px solid #D5D8DE;
    padding: 24px 24px 0 24px;
    &-title{
      font-size: 12px;
      line-height: 17px;
      color: #606266;
    }
    &-num{
      margin-top: 10px;
      padding-bottom: 20px;
      font-size: 16px;
      font-family: Source Han Sans SC;
      font-weight: bold;
      line-height: 24px;
      color: #303133;
    }
  }
}
.is-disabled {
  opacity: 0.3;
  cursor: not-allowed;
}
.is-disabled:hover {
  color: #98A1B4;
}
</style>
